import { api } from './missionStorageApi';
import '../../graphql/missions.generated';
import '../../graphql/actions.generated';
import type {
  GetMissionQuery,
  GetMissionsQuery,
  UpdateMissionMutation,
  DeleteMissionMutation,
  GetMissionQueryVariables,
  UpdateMissionMutationVariables,
  DeleteMissionMutationVariables,
} from '../../graphql/missions.generated';
import type {
  GetActionsQuery,
  GetActionsQueryVariables,
  CreateActionMutationVariables,
  UpdateActionMutationVariables,
  PrependUndockBeforeLoadMapMutationVariables,
} from '../../graphql/actions.generated';

export const missionStorageApiEnhanced = api.enhanceEndpoints({
  addTagTypes: ['Mission', 'Action'],
  endpoints: {
    GetMissions: {
      providesTags: (result: GetMissionsQuery | undefined) =>
        result
          ? [
            ...result.missions.map(({ id }) => ({ type: 'Mission' as const, id })),
            { type: 'Mission', id: 'LIST' },
          ]
          : [{ type: 'Mission', id: 'LIST' }],
    },
    GetMission: {
      providesTags: (
        _result: GetMissionQuery | undefined,
        _error: unknown,
        arg: GetMissionQueryVariables,
      ) => [{ type: 'Mission', id: arg.id }],
    },
    CreateMission: {
      invalidatesTags: [{ type: 'Mission', id: 'LIST' }],
    },
    UpdateMission: {
      invalidatesTags: (
        _result: unknown,
        _error: unknown,
        arg: UpdateMissionMutationVariables,
      ) => [{ type: 'Mission', id: arg.id }],
    },
    DeleteMission: {
      invalidatesTags: (
        _result: DeleteMissionMutation | undefined,
        _error: unknown,
        arg: DeleteMissionMutationVariables,
      ) => [
          { type: 'Mission', id: arg.id },
          { type: 'Mission', id: 'LIST' },
        ],
    },
    DeleteMissions: {
      invalidatesTags: [{ type: 'Mission', id: 'LIST' }],
    },
    GetActions: {
      providesTags: (
        result: GetActionsQuery | undefined,
        _error: unknown,
        arg: GetActionsQueryVariables,
      ) =>
        result
          ? [
            ...result.actions.map(({ id }) => ({ type: 'Action' as const, id })),
            { type: 'Action', id: `LIST-${arg.missionId}` },
          ]
          : [],
    },
    CreateAction: {
      invalidatesTags: (
        _result: unknown,
        _error: unknown,
        arg: CreateActionMutationVariables,
      ) => [
          { type: 'Action', id: `LIST-${arg.input.missionId}` },
        ],
    },
    UpdateAction: {
      invalidatesTags: (
        _result: unknown,
        _error: unknown,
        arg: UpdateActionMutationVariables,
      ) => [{ type: 'Action', id: arg.id }],
    },
    DeleteAction: {
      invalidatesTags: ['Action'], // Invalidate all action lists since we don't know missionId
    },
    ReorderAction: {
      invalidatesTags: ['Action'],
    },
    PrependUndockBeforeLoadMap: {
      invalidatesTags: (
        _result: unknown,
        _error: unknown,
        arg: PrependUndockBeforeLoadMapMutationVariables,
      ) => [
          { type: 'Action', id: `LIST-${arg.missionId}` },
        ],
    },
  },
});

export {
  useGetMissionsQuery,
  useGetMissionQuery,
  useCreateMissionMutation,
  useUpdateMissionMutation,
  useDeleteMissionMutation,
  useDeleteMissionsMutation,
} from '../../graphql/missions.generated';

export {
  useGetActionsQuery,
  useCreateActionMutation,
  useUpdateActionMutation,
  useReorderActionMutation,
  useDeleteActionMutation,
  usePrependUndockBeforeLoadMapMutation,
} from '../../graphql/actions.generated';
